export default __webpack_public_path__ + "static/media/menu_close.8ca34dca.svg";